import { useEffect, useState } from "react";
import Api from "../openapi";
import { PartnerUserBriefResponse } from "../openapi/client";

export default function useUsers() {
  const [userList, setUserList] = useState<PartnerUserBriefResponse[]>([]);
  useEffect(() => {
    const getUsers = async () => {
      try {
        const res = await Api.User.listBriefUsers();
        setUserList(res.data);
      } catch (error) {}
    };
    getUsers();
  }, []);
  return userList;
}
